import { loadStripe } from '@stripe/stripe-js';

const STRIPE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;

if (!STRIPE_KEY) {
  throw new Error('Missing Stripe publishable key');
}

export const stripePromise = loadStripe(STRIPE_KEY);

export const PRODUCTS = {
  LIFETIME: {
    id: 'prod_S93KRJQuf6zHpJ',
    priceId: 'price_1RElDTI3G1M8PMhOHWThb2gv',
    name: 'WAFManager Pro (Lifetime)',
    description: 'One-time payment for unlimited access',
    mode: 'payment',
    features: [
      'Unlimited domains',
      'Unlimited Cloudflare accounts',
      'All WAF templates',
      'Advanced DNS management',
      'Priority email support',
      'Bulk operations',
      'Custom templates',
      'Team management',
      'Free updates forever'
    ]
  }
} as const;

export type ProductId = keyof typeof PRODUCTS;